import { useContext } from "react";
import { AppUserInfoContext } from "@/shared/model/user/AppUserInfoContext.ts";
import type { UserDomainPermissions } from "@/shared/model/user/UserPermissions.ts";
import {
  UserFlags,
  UserPermissions,
} from "@/shared/model/user/UserPermissions.ts";
import { goToLoginWithTarget } from "@/shared/model/user/Logout.ts";

/**
 * @return User permissions if user is logged in, otherwise redirects to login page.
 */
export default function useUserPermissions(): UserPermissions {
  const user = useContext(AppUserInfoContext);
  if (user.permissions === undefined) {
    goToLoginWithTarget();
    return new UserPermissions(
      new Map<string, UserDomainPermissions>(),
      UserFlags.createNoFlags(),
    );
  }
  return user.permissions;
}
